import { OrnateDivider } from './KeralaDecor';
import './ThreePillars.css';

const pillars = [
  {
    icon: '🍛',
    title: 'Authentic Kerala Cuisine',
    body: 'Malabar biriyanis, slow-cooked curries, and tea-shop snacks, made the traditional way.'
  },
  {
    icon: '🥩',
    title: 'Fresh Meat & Seafood',
    body: 'Hand-cut Zabiha halal meat sourced from certified farms, delivered fresh throughout the week.'
  },
  {
    icon: '🍽️',
    title: 'Dine-In & Takeout',
    body: "Call ahead and we'll have it ready when you arrive."
  }
];

export default function ThreePillars() {
  return (
    <section className="tp">
      <div className="container tp__inner">
        <OrnateDivider />
        <div className="tp__grid">
          {pillars.map((p) => (
            <div className="tp__card" key={p.title}>
              <div className="tp__icon" aria-hidden="true">{p.icon}</div>
              <h3 className="tp__title">{p.title}</h3>
              <p className="tp__body">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
